import { render, staticRenderFns } from "./export.vue?vue&type=template&id=ecf64c7c&scoped=true"
import script from "./export.vue?vue&type=script&lang=ts"
export * from "./export.vue?vue&type=script&lang=ts"
import style0 from "./export.vue?vue&type=style&index=0&id=ecf64c7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf64c7c",
  null
  
)

export default component.exports